import { Button } from '@shared/components/ui/button';
import { faSliders } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

interface CreateManualTransactionButtonProps {
  onClick: () => void;
}

export const CreateManualTransactionButton = ({ onClick }: CreateManualTransactionButtonProps) => {
  const { t } = useTranslation('walletsModule');

  return (
    <Button variant="outline" size="default" onClick={onClick} data-testid="create-manual-transaction-button">
      <FontAwesomeIcon icon={faSliders} className="w-4 h-4 mr-2" />
      {t('manualTransaction.button')}
    </Button>
  );
};
